import { Modal } from '@fasstech/middle-design-system';

const ErrorOnSaveDocumentsModal = ({
  isDisplayed,
  errorSaveDocumentModalMessage,
  setErrorSaveDocumentModalMessage,
  button1Label,
  button2Label = 'Retour',
  onClick1,
  button2Variant = 'secondary'
}) => {
  const hideModal = () => {
    setErrorSaveDocumentModalMessage('');
  };

  return (
    <Modal
      isDisplayed={isDisplayed}
      button1Label={button1Label}
      button2Variant={button2Variant}
      button2Label={button2Label}
      onClose={hideModal}
      onClick1={onClick1}
      onClick2={hideModal}
      icon="circleReject"
      className="w-[80vw] max-w-2xl">
      <div className="mx-auto text-primary font-medium text-xl text-center">
        <div className="text-2xl font-semibold mb-4">Attention</div>
        <p dangerouslySetInnerHTML={{ __html: errorSaveDocumentModalMessage }}></p>
      </div>
    </Modal>
  );
};

export default ErrorOnSaveDocumentsModal;
